<template>
  <div v-if="chemistry.BELKI" class="c-product-chemistry q-mt-md s-font-sm">
    <div class="c-chemistry__table row no-wrap justify-between bg-grey-3 text-center q-px-md q-py-sm">
      <div class="col-auto">
        <q-btn-toggle
          v-model="weightMode"
          dense
          unelevated
          no-caps
          toggle-color="primary"
          color="transparent"
          text-color="grey-8"
          :options="[
            { label: '100г', value: '100' },
            { label: `${chemistry.WEIGHT}г`, value: 'full' }
          ]"
          size="xs"
          class="c-chemistry__toggle"
        />
        <div class="__name">пищ. цен.</div>
      </div>
      <div class="col-auto" v-if="chemistry.KKAL">
        <div class="__val">{{ displayValues.KKAL }}</div>
        <div class="__name">ккал</div>
      </div>
      <div class="col-auto">
        <div class="__val">{{ displayValues.BELKI }}</div>
        <div class="__name">белки</div>
      </div>
      <div class="col-auto">
        <div class="__val">{{ displayValues.ZHIRY }}</div>
        <div class="__name">жиры</div>
      </div>
      <div class="col-auto">
        <div class="__val">{{ displayValues.UGLEVODY }}</div>
        <div class="__name">угл</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import { ProductModel } from "@/modules/shop/composable/useProduct";
import { computed, ref, toRefs } from "vue";

export type ProductSetItemsProps = {
  product: ProductModel
}

const props = withDefaults(defineProps<ProductSetItemsProps>(), {})

const {product} = toRefs(props)

const weightMode = ref<'100' | 'full'>('100')

const chemistry = computed(() => {
  return {
    WEIGHT: product.value.PROPERTIES.WEIGHT,
    KKAL: parseFloat(product.value.PROPERTIES.KKAL || '0'),
    BELKI: parseFloat(product.value.PROPERTIES.BELKI || '0'),
    ZHIRY: parseFloat(product.value.PROPERTIES.ZHIRY || '0'),
    UGLEVODY: parseFloat(product.value.PROPERTIES.UGLEVODY || '0'),
  }
})

const displayWeight = computed(() => {
  return weightMode.value === '100' ? 100 : chemistry.value.WEIGHT
})

const displayValues = computed(() => {
  const koef = weightMode.value === '100'
    ? 1
    : parseFloat(product.value.PROPERTIES.WEIGHT || '0') / 100

  return {
    KKAL: Math.round(chemistry.value.KKAL * koef),
    BELKI: Math.round(chemistry.value.BELKI * koef),
    ZHIRY: Math.round(chemistry.value.ZHIRY * koef),
    UGLEVODY: Math.round(chemistry.value.UGLEVODY * koef),
  }
})

</script>

<style lang="scss" scoped>

.c-chemistry__toggle {
  margin-bottom: 2px;

  :deep(.q-btn) {
    padding: 2px 6px !important;
    font-size: 10px !important;
    min-height: auto !important;
    font-weight: 500 !important;
    border-radius: 4px !important;
  }

  :deep(.q-btn--active) {
    border: 1px solid currentColor !important;
  }
}

.c-chemistry__table {
  border-radius: 10px;

  > div {
    padding-right: 6px;
    padding-left: 6px;
    text-align: center;

    &:first-child {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &:last-child {

    }

    .__name {
      font-size: 11px;
    }
  }
}

</style>
